

// eslint-disable-next-line no-undef
const isPro = process.env.NODE_ENV === 'production';
//const isPro = true

const MSG = '接口返回数据异常!';

const API_URL = {
	sealListURL: '/ucloudseal/getSignsignature',
	signTimeWord: '/ucloudseal/v1/signTimeWord',
	updateQrcodeStatus: '/ucloudseal/updateqrcodestatus',
	verifyTimeSign: '/ucloudseal/v1/verifyTimeSign'
};

const ajaxService = (options) => {
	const { url, data } = options
	return new Promise((resolve, reject) => {
		window.$.ajax({
				url,
				type: "post",
				headers: {"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"},
				data,
				success:function(data) {
					return resolve(data)
				},
				error: function(err) {
					return reject(err)
				},
				dataType:"json"
			});
	})
}

const createPostRequest = (host) => {
	return (url, data, doData = true) => {
		const p = ajaxService({
			url: isPro ? host + url : url,
			data,
		})
		return doData ? p.then((result) => {
				return result.status === 0
					? Promise.resolve(result.data)
					: Promise.reject(result.msg || MSG);
			})
			.catch((e) => {
				return Promise.reject(e);
			}) : p;
	};
};

export const getSealListFromApi = (signatureHostUrl, data) => {
	return createPostRequest(signatureHostUrl)(API_URL.sealListURL, data);
};

export const serializeSealListData = (list) => {
	return Array.isArray(list)
		? list.map((item) => {
				item.sealName = item.signname;
				item.sealId = item.signid;
				item.downloadUrl = 'data:image/png;base64,' + item.signdata;
				item.isChoosed = false;
				return item;
				// eslint-disable-next-line no-mixed-spaces-and-tabs
		  })
		: list;
};

export const signTimeWordFromApi = (signatureHostUrl, data) => {
	return createPostRequest(signatureHostUrl)(API_URL.signTimeWord, data, false);
};

export const updateQrcodeStatusFromApi = (signatureHostUrl, data) => {
	return createPostRequest(signatureHostUrl)(API_URL.updateQrcodeStatus, data, false);
};

export const verifyTimeSignFromApi = (signatureHostUrl, data) => {
  return createPostRequest(signatureHostUrl)(API_URL.verifyTimeSign, data, false);
}
